import React from "react";
import { Link } from "react-router-dom";

export default function FounderHeroSection({ data }) {
  return (
    <section
      className={`founder-hero ${data.className || ""}`.trim()}
      style={{ backgroundImage: `url(${data.backgroundImage})` }}
    >
      <div className="founder-hero-overlay" />
      <div className="container founder-hero-content">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-8">
            <nav className="founder-breadcrumbs" aria-label="Breadcrumb">
              {data.breadcrumbs.map((item, index) => (
                <React.Fragment key={item.label}>
                  {item.to ? <Link to={item.to}>{item.label}</Link> : <span>{item.label}</span>}
                  {index < data.breadcrumbs.length - 1 && <i className="fa-solid fa-angle-right" />}
                </React.Fragment>
              ))}
            </nav>
            <h1 className="heading text-white text-capitalize">{data.title}</h1>
            <p className="text-white">{data.description}</p>
          </div>
        </div>
        
      </div>
    </section>
  );
}
